/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.core.designsystem.theme

import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF0673BA)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFCEEAFD)
val onPrimaryContainerLight = Color(0xFF033D63)
val secondaryLight = Color(0xFF984061)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFF0DBE3)
val onSecondaryContainerLight = Color(0xFF361722)
val tertiaryLight = Color(0xFF7D4996)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0XFFE9DDEE)
val onTertiaryContainerLight = Color(0xFF2B1934)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF8F9FF)
val onBackgroundLight = Color(0xFF181C20)
val surfaceLight = Color(0xFFF8F9FF)
val onSurfaceLight = Color(0xFF181C20)
val surfaceVariantLight = Color(0xFFDCE3EF)
val onSurfaceVariantLight = Color(0xFF404751)
val outlineLight = Color(0xFF717882)
val outlineVariantLight = Color(0xFFC0C7D2)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2D3136)
val inverseOnSurfaceLight = Color(0xFFEEF1F7)
val inversePrimaryLight = Color(0xFF9BCAFF)
val surfaceDimLight = Color(0xFFD8DAE0)
val surfaceBrightLight = Color(0xFFF8F9FF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF1F3FA)
val surfaceContainerLight = Color(0xFFECEEF4)
val surfaceContainerHighLight = Color(0xFFE6E8EE)
val surfaceContainerHighestLight = Color(0xFFE0E2E9)

val primaryDark = Color(0xFF9CD6FC)
val onPrimaryDark = Color(0xFF033D63)
val primaryContainerDark = Color(0xFF044C7C)
val onPrimaryContainerDark = Color(0xFFE6F5FE)
val secondaryDark = Color(0xFFD9A5B8)
val onSecondaryDark = Color(0xFF361722)
val secondaryContainerDark = Color(0xFF5A2639)
val onSecondaryContainerDark = Color(0xFFF0DBE3)
val tertiaryDark = Color(0xFFC7A9D6)
val onTertiaryDark = Color(0xFF3A2145)
val tertiaryContainerDark = Color(0xFF653A78)
val onTertiaryContainerDark = Color(0xFFF4EEF7)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF101418)
val onBackgroundDark = Color(0xFFE0E2E9)
val surfaceDark = Color(0xFF101418)
val onSurfaceDark = Color(0xFFE0E2E9)
val surfaceVariantDark = Color(0xFF404751)
val onSurfaceVariantDark = Color(0xFFC0C7D2)
val outlineDark = Color(0xFF8A919C)
val outlineVariantDark = Color(0xFF404751)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE0E2E9)
val inverseOnSurfaceDark = Color(0xFF2D3136)
val inversePrimaryDark = Color(0xFF0062A0)
val surfaceDimDark = Color(0xFF101418)
val surfaceBrightDark = Color(0xFF36393E)
val surfaceContainerLowestDark = Color(0xFF0B0E13)
val surfaceContainerLowDark = Color(0xFF181C20)
val surfaceContainerDark = Color(0xFF1C2025)
val surfaceContainerHighDark = Color(0xFF272A2F)
val surfaceContainerHighestDark = Color(0xFF32353A)
